import type { FC } from 'react';
import type { RuleTaskCondition } from '../../types';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import { AddConditionButton, TaskOperator } from '../RuleEditComponents';
import ComparisonConditionForm from './ComparisonConditionForm';
import SingleConditionForm from './SingleConditionForm';

const ConditionsGroup: FC<{ condition: RuleTaskCondition; index: number }> = observer(
  ({ condition, index: indexTask }) => {
    return (
      <Box sx={{ display: 'flex', flex: 1, gap: 3, flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'start' }}>
          <Typography variant="h4" sx={{ fontWeight: 500 }}>
            Condition group
          </Typography>
          <TaskOperator indexTask={indexTask} />
        </Box>
        {condition.conditions.map((item, indexCondition) => {
          const isComparisonCondition = Object.hasOwn(item, 'metric') && Object.hasOwn(item, 'second_metric');
          return isComparisonCondition ? (
            <ComparisonConditionForm
              indexVariant={undefined}
              key={`TaskCondition:Comparison:${item.metric}.${item.second_metric}.${item.operator}.${item.type}:${indexCondition}`}
              indexCondition={indexCondition}
              indexTask={indexTask}
            />
          ) : (
            <SingleConditionForm
              indexVariant={undefined}
              key={`TaskCondition:Single:${item.metric}.${item.operator}.${item.type}:${indexCondition}`}
              indexCondition={indexCondition}
              indexTask={indexTask}
            />
          );
        })}
        <Box>
          <AddConditionButton indexTask={indexTask} />
        </Box>
      </Box>
    );
  }
);

export default ConditionsGroup;
